module.exports = __webpack_public_path__ + "static/Pro-manchester_Logo-3605711e1f13b6dc7f03c40ff6f3e775.png";